import React from 'react';
import AnalyticsTracking from './components/AnalyticsTracking';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import LandingPage from './pages/LandingPage';
import ContactPage from './pages/ContactPage';
import CoachingPage from './pages/CoachingPage';
import SweWorkshopPage from './pages/SweWorkshopPage';
import SweThankYouPage from './pages/SweThankYouPage';
import SystemDesignRoadmapPage from './pages/SystemDesignRoadmapPage';
import ResumeDownloadPage from './pages/ResumeDownloadPage';
import LeetcodeRoadmapPage from './pages/LeetcodeRoadmapPage';
import BehavioralQuestionsPage from './pages/BehavioralQuestionsPage';
import SweLandJobPage from './pages/SweLandJobPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import ResumeGuidePage from './pages/ResumeGuidePage';
import CheckoutPage from './pages/CheckoutPage';
import CompleteDsaCoursePage from './pages/CompleteDsaCoursePage';
import SystemDesignMasterclassPage from './pages/SystemDesignMasterclassPage';
import SkoolAdsLandingPage from './pages/SkoolAdsLandingPage';
import JoinSkoolLandingPage from './pages/JoinSkoolLandingPage';
import WelcomeCallWithRayPage from './pages/WelcomeCallWithRayPage';
import FreeHelpWithRayPage from './pages/FreeHelpWithRayPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import LegalFooter from './components/LegalFooter';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2E3440', // Nord0 - dark blue-gray
    },
    secondary: {
      main: '#88C0D0', // Nord8 - light blue
    },
    background: {
      default: '#2E3440', // Nord0 - polar night
      paper: '#3B4252', // Nord1 - darker polar night
    },
    text: {
      primary: '#ECEFF4', // Nord6 - snow storm white
      secondary: '#88C0D0', // Nord8 - frost blue
    },
    info: {
      main: '#81A1C1', // Nord9 - darker frost blue
    },
    success: {
      main: '#A3BE8C', // Nord14 - aurora green
    },
    warning: {
      main: '#EBCB8B', // Nord13 - aurora yellow
    },
    error: {
      main: '#BF616A', // Nord11 - aurora red
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: '#3B4252', // Nord1
          border: '1px solid #434C5E', // Nord2
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#3B4252', // Nord1
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AnalyticsTracking />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/swe-workshop" element={<SweWorkshopPage />} />
          <Route path="/swe-thank-you" element={<SweThankYouPage />} />
          <Route path="/system-design-roadmap" element={<SystemDesignRoadmapPage />} />
          <Route path="/resume-download" element={<ResumeDownloadPage />} />
          <Route path="/leetcode-roadmap" element={<LeetcodeRoadmapPage />} />
          <Route path="/10-behavioral-questions" element={<BehavioralQuestionsPage />} />
          <Route path="/land-a-swe-job-in-90-days" element={<SweLandJobPage />} />
          <Route path="/resume-guide" element={<ResumeGuidePage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/complete-dsa-course" element={<CompleteDsaCoursePage />} />
          <Route path="/system-design-masterclass" element={<SystemDesignMasterclassPage />} />
          <Route path="/free-skool" element={<SkoolAdsLandingPage />} />
          <Route path="/join-skool" element={<JoinSkoolLandingPage />} />
          <Route path="/welcome-call-with-ray" element={<WelcomeCallWithRayPage />} />
          <Route path="/free-help-with-ray" element={<FreeHelpWithRayPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <LegalFooter />
      </Router>
    </ThemeProvider>
  );
}

export default App;
